import apiClient from '@/services/axios'

export async function get() {
  var response = await apiClient.get('/me/update-last-login')
  if (response) {
    return response.data
  }

  throw new Error('Unable to update last login.')
}
